import {MODAL_TYPE, showModal} from '../../../../forecast-app/shared/components/modals/generic_modal_conductor';

export interface DeleteNovaCategoryModalPayload {
	categoryId: string;
	categoryName: string;
	agentCount: number;
	onDeleted: () => void;
}

export const showDeleteNovaCategoryModal = (props: DeleteNovaCategoryModalPayload): void => {
	showModal({type: MODAL_TYPE.NOVA_DELETE_CATEGORY, ...props});
};
